// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"be8e2785","832":"4f2fa5cc","972":"a5a54942"}[chunkId] + ".chunk.js";
};